import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import { MODALS } from "@/constants/modals"
import { useAttendLectureMutation } from "@/queries/mutations/enrolledRoundsMutations"
import { useStore } from "@/zustand/store"

export default function AttendLectureModal() {
  const { t } = useTranslation()

  const modalData = useStore(
    (state) => state.modalsStates[MODALS.lecture.attend]
  )
  const lecture = modalData?.lecture
  const round = modalData?.round

  const editModalState = useStore((state) => state.editModalState)

  const attendLecture = useAttendLectureMutation(round?.id)

  if (!modalData) return null

  return (
    <Button
      variant="primary"
      className="w-50 m-auto justify-content-center"
      onClick={() => {
        if (lecture?.id) {
          attendLecture.mutate(lecture)
        }
        setTimeout(() => {
          window.open(round?.google_meet_link)
        }, 1000)
        editModalState(MODALS.lecture.attend, undefined)
      }}
    >
      {t("attendLecture.title")}
    </Button>
  )
}
